<div class="annotations-card controls-container bg-neutral-100 dark:bg-slate-900 mt-3">
  
  <!-- Nagłówek - klikalny do rozwinięcia -->
  <div class="flex items-center justify-between cursor-pointer select-none" (click)="toggleExpanded()">
    <div class="font-medium text-base flex items-center pl-[4.5px]">
      Adnotacje
      <span *ngIf="activeAnnotationsCount > 0" class="ml-2 px-1.5 py-0.5 text-xs font-medium leading-none rounded-md bg-primary/10 text-primary">
        {{ activeAnnotationsCount }}
      </span>
    </div>
    <mat-icon class="icon-size-5 text-gray-500 transition-transform duration-200" 
              [class.rotate-180]="isExpanded"
              [svgIcon]="'tabler_outline:chevron-down'"></mat-icon>
  </div>

  <!-- Ostrzeżenie o wymaganym zwolnieniu VAT (zawsze widoczne gdy dotyczy) -->
  <div *ngIf="showVatExemptionWarning && !isExpanded" 
       class="mt-2 p-2 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 cursor-pointer"
       (click)="isExpanded = true">
    <div class="text-sm text-orange-600 dark:text-orange-400 flex items-center">
      <mat-icon class="icon-size-4 mr-1 text-amber-600 dark:text-amber-400" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
      Faktura zawiera pozycje ze stawką "zw" - kliknij aby podać podstawę prawną
    </div>
  </div>

  <!-- Zawartość panelu - rozwijalna -->
  <div *ngIf="isExpanded" class="mt-3">

    <!-- Błędy walidacji -->
    <div *ngIf="validationErrors.length > 0" class="mb-3 p-2 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
      <div *ngFor="let error of validationErrors" class="text-sm text-red-600 dark:text-red-400 flex items-center">
        <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:alert-circle'"></mat-icon>
        {{ error }}
      </div>
    </div>

    <!-- Ostrzeżenie o wymaganym zwolnieniu VAT -->
    <div *ngIf="showVatExemptionWarning" class="mb-3 p-2 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800">
      <div class="text-sm text-orange-600 dark:text-orange-400 flex items-center">
        <mat-icon class="icon-size-4 mr-1 text-amber-600 dark:text-amber-400" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
        Faktura zawiera pozycje ze stawką "zw" - wymagane jest podanie podstawy prawnej zwolnienia
      </div>
    </div>

    <!-- Lista adnotacji -->
    <div class="space-y-3">

      <!-- Mechanizm podzielonej płatności (MPP) -->
      <div class="annotation-item">
        <mat-checkbox 
          color="primary"
          [checked]="invoice.annotations.isSplitPayment || false"
          [disabled]="isAnnotationDisabled('splitPayment')"
          [matTooltip]="getDisabledTooltip('splitPayment')"
          (change)="onSimpleAnnotationChange('isSplitPayment', $event.checked)">
          <span class="font-medium">Mechanizm podzielonej płatności</span>
          <span class="text-xs text-gray-500 dark:text-gray-400 ml-1">(MPP)</span>
        </mat-checkbox>
        <p class="text-xs text-gray-500 dark:text-gray-400 ml-[44px]">
          Nabywca płaci VAT na specjalne konto VAT sprzedawcy
        </p>
        
        <!-- Konto VAT dla MPP -->
        <div *ngIf="isSplitPaymentEnabled" class="ml-[44px] mt-3">
          <mat-form-field *ngIf="bankAccounts.length > 0" class="w-full" subscriptSizing="dynamic">
            <mat-label>Konto VAT</mat-label>
            <mat-select [value]="invoice.vatAccountNumber" (valueChange)="onVatAccountChange($event)">
              <mat-option *ngFor="let bankAccount of bankAccounts" [value]="bankAccount.accountNumber">
                {{ bankAccount.bank }}: {{ bankAccount.accountNumber }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="bankAccounts.length === 0" class="w-full" subscriptSizing="dynamic">
            <mat-label>Konto VAT</mat-label>
            <input matInput 
                   [value]="invoice.vatAccountNumber || ''" 
                   (input)="onVatAccountChange($any($event.target).value)" />
            <mat-hint>Podaj numer konta VAT</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <!-- Odwrotne obciążenie -->
      <div class="annotation-item">
        <mat-checkbox 
          color="primary"
          [checked]="invoice.annotations.isReverseCharge || false"
          (change)="onSimpleAnnotationChange('isReverseCharge', $event.checked)">
          <span class="font-medium">Odwrotne obciążenie</span>
        </mat-checkbox>
        <p class="text-xs text-gray-500 dark:text-gray-400 ml-[44px]">
          Nabywca sam rozlicza VAT (reverse charge)
        </p>
      </div>

      <!-- Metoda kasowa -->
      <div class="annotation-item">
        <mat-checkbox 
          color="primary"
          [checked]="invoice.annotations.isCashMethod || false"
          [disabled]="isAnnotationDisabled('cashMethod')"
          [matTooltip]="getDisabledTooltip('cashMethod')"
          (change)="onSimpleAnnotationChange('isCashMethod', $event.checked)">
          <span class="font-medium">Metoda kasowa</span>
        </mat-checkbox>
        <p class="text-xs text-gray-500 dark:text-gray-400 ml-[44px]">
          VAT rozliczany w momencie otrzymania zapłaty
        </p>
      </div>

      <!-- Samofakturowanie -->
      <div class="annotation-item">
        <mat-checkbox 
          color="primary"
          [checked]="invoice.annotations.isSelfInvoicing || false"
          (change)="onSimpleAnnotationChange('isSelfInvoicing', $event.checked)">
          <span class="font-medium">Samofakturowanie</span>
        </mat-checkbox>
        <p class="text-xs text-gray-500 dark:text-gray-400 ml-[44px]">
          Faktura wystawiona przez nabywcę w imieniu sprzedawcy
        </p>
      </div>

      <!-- Procedura marży -->
      <div class="annotation-item">
        <mat-checkbox 
          color="primary"
          [checked]="isMarginProcedureEnabled"
          (change)="onMarginProcedureToggle($event.checked)">
          <span class="font-medium">Procedura marży</span>
        </mat-checkbox>
        <p class="text-xs text-gray-500 dark:text-gray-400 ml-[44px]">
          Opodatkowanie marży (towary używane, dzieła sztuki, biura podróży)
        </p>
        
        <!-- Wybór procedury marży -->
        <div *ngIf="isMarginProcedureEnabled" class="ml-[44px] mt-3">
          <mat-form-field class="w-full" subscriptSizing="dynamic">
            <mat-label>Rodzaj procedury</mat-label>
            <mat-select 
              [value]="currentMarginProcedureId" 
              (selectionChange)="onMarginProcedureChange($event.value)">
              <mat-option *ngFor="let procedure of marginProcedures" [value]="procedure.id">
                {{ procedure.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Zwolnienie z VAT -->
      <div class="annotation-item">
        <mat-checkbox 
          color="primary"
          [checked]="isVatExemptionEnabled"
          (change)="onVatExemptionToggle($event.checked)">
          <span class="font-medium">Zwolnienie z VAT</span>
        </mat-checkbox>
        <p class="text-xs text-gray-500 dark:text-gray-400 ml-[44px]">
          Dostawa/usługa zwolniona z podatku VAT
        </p>
        
        <!-- Konfiguracja zwolnienia z VAT (nowy model KSeF) -->
        <div *ngIf="isVatExemptionEnabled" class="ml-[44px] mt-3 space-y-3">
          
          <!-- Wybór typu podstawy prawnej (A/B/C) -->
          <mat-form-field class="w-full" subscriptSizing="dynamic" [class.vat-exemption-required]="isExemptionTypeMissing">
            <mat-label>Typ podstawy prawnej</mat-label>
            <mat-select
              [value]="selectedExemptionType"
              (selectionChange)="onExemptionTypeChange($event.value)">
              <mat-option [value]="null">-- Wybierz typ --</mat-option>
              <mat-option *ngFor="let type of vatExemptionTypes" [value]="type.type">
                {{ type.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <p *ngIf="isExemptionTypeMissing" class="text-xs text-red-500 dark:text-red-400 -mt-2">
            Wybierz typ podstawy prawnej
          </p>

          <!-- Pole na treść podstawy prawnej (widoczne gdy zwolnienie włączone) -->
          <mat-form-field class="w-full" subscriptSizing="dynamic" [class.vat-exemption-required]="isExemptionBasisMissing">
            <mat-label>Treść podstawy prawnej</mat-label>
            <textarea
              matInput
              [(ngModel)]="exemptionLegalBasis"
              (ngModelChange)="onLegalBasisChange($event)"
              (blur)="onLegalBasisBlur()"
              rows="2"
              [placeholder]="getExemptionPlaceholder()">
            </textarea>
            <mat-hint *ngIf="!isExemptionBasisMissing">Wpisz konkretny przepis ustawy, dyrektywy lub inną podstawę prawną</mat-hint>
          </mat-form-field>
          <p *ngIf="isExemptionBasisMissing" class="text-xs text-red-500 dark:text-red-400 -mt-2">
            Uzupełnij treść podstawy prawnej
          </p>

          <!-- Toggle wyświetlania na dokumencie -->
          <mat-slide-toggle 
            color="primary"
            [checked]="invoice.annotations.vatExemption?.showOnDocument || false"
            (change)="onShowVatExemptionChange($event.checked)">
            <span class="text-sm">Pokaż podstawę na dokumencie</span>
          </mat-slide-toggle>
        </div>
      </div>

    </div>

  </div>

</div>
